import { isArray } from "jquery";
import {
  LIST_PARTNER_FAILED,
  LIST_PARTNER_REQ,
  LIST_PARTNER_SUCCESS,
} from "../Constants/partnerConstant";
import axiosConfig from "../Core/axiosConfig";

export const listPartner = () => async (dispatch) => {
  try {
    dispatch({ type: LIST_PARTNER_REQ });
    const { data } = await axiosConfig.get("/affiliatepartner");
    if (!isArray(data?.Result) && data?.Result?.include("Error")) {
      dispatch({ type: LIST_PARTNER_FAILED, payload: data?.Result });
    } else {
      dispatch({ type: LIST_PARTNER_SUCCESS, payload: data?.Result });
    }
  } catch (error) {
    dispatch({
      type: LIST_PARTNER_FAILED,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};
